{
  "ar-EG": {
    "zoomintitle": "تكبير",
    "zoomouttitle": "تصغير",
    "aroundme1": "إظهار النقاط المهمة في",
    "aroundme2": "كيلومترات من حولي"
  },
  "ar-SA": {
    "zoomintitle": "تكبير",
    "zoomouttitle": "تصغير",
    "aroundme1": "إظهار النقاط المهمة في",
    "aroundme2": "كيلومترات من حولي"
  },
  "ca-ES": {
    "zoomintitle": "Ampliar",
    "zoomouttitle": "Disminuir el zoom",
    "aroundme1": "Mostra els PDI a",
    "aroundme2": "quilòmetres al meu voltant"
  },
  "cs-CZ": {
    "zoomintitle": "Přiblížit",
    "zoomouttitle": "Oddálit",
    "aroundme1": "Zobrazit BZ v",
    "aroundme2": "kilometry kolem mě"
  },
  "da-DK": {
    "zoomintitle": "Zoom ind",
    "zoomouttitle": "Zoome ud",
    "aroundme1": "Vis POI'er kl",
    "aroundme2": "kilometer omkring mig"
  },
  "de-AT": {
    "zoomintitle": "Hineinzoomen",
    "zoomouttitle": "Rauszoomen",
    "aroundme1": "POIs anzeigen unter",
    "aroundme2": "Kilometer um mich herum"
  },
  "de-CH": {
    "zoomintitle": "Hineinzoomen",
    "zoomouttitle": "Rauszoomen",
    "aroundme1": "POIs anzeigen unter",
    "aroundme2": "Kilometer um mich herum"
  },
  "de-DE": {
    "zoomintitle": "Hineinzoomen",
    "zoomouttitle": "Rauszoomen",
    "aroundme1": "POIs anzeigen unter",
    "aroundme2": "Kilometer um mich herum"
  },
  "en-CA": {
    "zoomintitle": "Zoom in",
    "zoomouttitle": "Zoom out",
    "aroundme1": "Show POIs at",
    "aroundme2": "kilometers around me"
  },
  "en-GB": {
    "zoomintitle": "Zoom in",
    "zoomouttitle": "Zoom out",
    "aroundme1": "Show POIs at",
    "aroundme2": "kilometers around me"
  },
  "en-HK": {
    "zoomintitle": "Zoom in",
    "zoomouttitle": "Zoom out",
    "aroundme1": "Show POIs at",
    "aroundme2": "kilometers around me"
  },
  "en-IE": {
    "zoomintitle": "Zoom in",
    "zoomouttitle": "Zoom out",
    "aroundme1": "Show POIs at",
    "aroundme2": "kilometers around me"
  },
  "en-IN": {
    "zoomintitle": "Zoom in",
    "zoomouttitle": "Zoom out",
    "aroundme1": "Show POIs at",
    "aroundme2": "kilometers around me"
  },
  "en-US": {
    "zoomintitle": "Zoom in",
    "zoomouttitle": "Zoom out",
    "aroundme1": "Show POIs at",
    "aroundme2": "kilometers around me"
  },
  "es-ES": {
    "zoomintitle": "Acercarse",
    "zoomouttitle": "Disminuir el zoom",
    "aroundme1": "Mostrar puntos de interés en",
    "aroundme2": "kilómetros a mi alrededor"
  },
  "es-MX": {
    "zoomintitle": "Acercarse",
    "zoomouttitle": "Disminuir el zoom",
    "aroundme1": "Mostrar puntos de interés en",
    "aroundme2": "kilómetros a mi alrededor"
  },
  "fi-FI": {
    "zoomintitle": "Lähennä",
    "zoomouttitle": "Loitontaa",
    "aroundme1": "Näytä KP:t osoitteessa",
    "aroundme2": "kilometriä ympärilläni"
  },
  "fr-BE": {
    "zoomintitle": "Zoomer avant",
    "zoomouttitle": "Zoomer arrière",
    "aroundme1": "Afficher les POI à",
    "aroundme2": "km autour de moi"
  },
  "fr-CA": {
    "zoomintitle": "Zoomer avant",
    "zoomouttitle": "Zoomer arrière",
    "aroundme1": "Afficher les POI à",
    "aroundme2": "km autour de moi"
  },
  "fr-CH": {
    "zoomintitle": "Zoomer avant",
    "zoomouttitle": "Zoomer arrière",
    "aroundme1": "Afficher les POI à",
    "aroundme2": "km autour de moi"
  },
  "fr-FR": {
    "zoomintitle": "Zoomer avant",
    "zoomouttitle": "Zoomer arrière",
    "aroundme1": "Afficher les POI à",
    "aroundme2": "km autour de moi"
  },
  "hi-IN": {
    "zoomintitle": "ज़ूम इन",
    "zoomouttitle": "ज़ूम आउट",
    "aroundme1": "POI यहां दिखाएं",
    "aroundme2": "मेरे चारों ओर किलोमीटर"
  },
  "hu-HU": {
    "zoomintitle": "Nagyítás",
    "zoomouttitle": "Kicsinyítés",
    "aroundme1": "POI-k megjelenítése itt:",
    "aroundme2": "kilométerre körülöttem"
  },
  "id-ID": {
    "zoomintitle": "Perbesar",
    "zoomouttitle": "Perkecil",
    "aroundme1": "Tampilkan POI di",
    "aroundme2": "kilometer di sekitarku"
  },
  "it-IT": {
    "zoomintitle": "Ingrandire",
    "zoomouttitle": "Rimpicciolisci",
    "aroundme1": "Mostra PDI a",
    "aroundme2": "chilometri intorno a me"
  },
  "ja-JP": {
    "zoomintitle": "ズームイン",
    "zoomouttitle": "ズームアウトする",
    "aroundme1": "POI を表示",
    "aroundme2": "私の周りのキロメートル"
  },
  "ko-KR": {
    "zoomintitle": "확대",
    "zoomouttitle": "축소",
    "aroundme1": "POI 표시 위치",
    "aroundme2": "내 주변 킬로미터"
  },
  "nb-NO": {
    "zoomintitle": "Zoom inn",
    "zoomouttitle": "Zoome ut",
    "aroundme1": "Vis POI kl",
    "aroundme2": "kilometer rundt meg"
  },
  "nl-BE": {
    "zoomintitle": "In zoomen",
    "zoomouttitle": "Uitzoomen",
    "aroundme1": "Toon POI's op",
    "aroundme2": "kilometer om mij heen"
  },
  "nl-NL": {
    "zoomintitle": "In zoomen",
    "zoomouttitle": "Uitzoomen",
    "aroundme1": "Toon POI's op",
    "aroundme2": "kilometer om mij heen"
  },
  "pl-PL": {
    "zoomintitle": "Zbliżenie",
    "zoomouttitle": "Pomniejsz",
    "aroundme1": "Pokaż POI w",
    "aroundme2": "kilometrów wokół mnie"
  },
  "pt-BR": {
    "zoomintitle": "Mais Zoom",
    "zoomouttitle": "Reduzir o zoom",
    "aroundme1": "Mostrar POIs em",
    "aroundme2": "quilômetros ao meu redor"
  },
  "pt-PT": {
    "zoomintitle": "Mais Zoom",
    "zoomouttitle": "Reduzir o zoom",
    "aroundme1": "Mostrar POIs em",
    "aroundme2": "quilômetros ao meu redor"
  },
  "ru-RU": {
    "zoomintitle": "Приблизить",
    "zoomouttitle": "Уменьшить",
    "aroundme1": "Показать POI на",
    "aroundme2": "километры вокруг меня"
  },
  "sv-SE": {
    "zoomintitle": "Zooma in",
    "zoomouttitle": "Zooma ut",
    "aroundme1": "Visa POIs kl",
    "aroundme2": "kilometer runt mig"
  },
  "th-TH": {
    "zoomintitle": "ขยายเข้า",
    "zoomouttitle": "ซูมออก",
    "aroundme1": "แสดง POI ได้ที่",
    "aroundme2": "กิโลเมตรรอบตัวฉัน"
  },
  "tr-TR": {
    "zoomintitle": "Yakınlaştır",
    "zoomouttitle": "Uzaklaştır",
    "aroundme1": "İÇN'leri şurada göster:",
    "aroundme2": "çevremdeki kilometrelerce"
  },
  "zh-CN": {
    "zoomintitle": "放大",
    "zoomouttitle": "缩小",
    "aroundme1": "显示兴趣点",
    "aroundme2": "我周围公里数"
  },
  "zh-HK": {
    "zoomintitle": "放大",
    "zoomouttitle": "缩小",
    "aroundme1": "显示兴趣点",
    "aroundme2": "我周围公里数"
  },
  "zh-TW": {
    "zoomintitle": "放大",
    "zoomouttitle": "缩小",
    "aroundme1": "显示兴趣点",
    "aroundme2": "我周围公里数"
  }
}